import classNames from 'classnames/bind';
import styles from './FormSelect.module.scss';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { ChevronDown } from 'components/_icons/ChevronDown/ChevronDown';

let cx = classNames.bind(styles);

function errorText(error, name, label) {
	if (error[name].type === 'required') {
		return !error[name].message ? 'Required' : error[name].message;
	} else {
		return !error[name].message ? `Invalid ${label}` : error[name].message;
	}
}

export function FormSelect({ label, id, required, className, name, children, multiple, ...props }) {
	const classNameArray = className?.split(' ') || [];
	const [isFocused, setIsFocused] = useState(false);
	const handleFocus = () => setIsFocused(true);
	const handleBlur = () => setIsFocused(false);
	const {
		register,
		formState: { errors, dirtyFields },
	} = useFormContext();

	const registerOptions = {
		required: required,
		onBlur: handleBlur,
	};

	return (
		<div className={cx(['ns_select-container', 'select-container', isFocused && 'in-focus', errors?.[name] && 'error', dirtyFields?.[name] && 'dirty', ...classNameArray])}>
			{label && <label className={cx(['ns_label', 'label'])} htmlFor={id} dangerouslySetInnerHTML={{ __html: label + (required.value ? '*' : '') }} />}
			<div className={cx(['select-wrapper'])}>
				<select className={cx(['ns_select', 'select'])} id={id} {...register(name, registerOptions)} aria-describedby={`${id}-help`} onFocus={handleFocus} multiple={multiple} {...props}>
					{children}
				</select>
				{!multiple && <ChevronDown className={cx(['select-arrow'])} />}
			</div>
			{errors?.[name] && (
				<small role="alert" id={`${id}-help`} className={cx(['select-error'])}>
					{errorText(errors, name, label)}
				</small>
			)}
		</div>
	);
}
